/* Florema · refresh de la ficha de producto (oct 2026)
   Ficha estilo Polène (escritorio: fotos a pantalla completa a la izquierda; celular: orden de venta),
   selector de aroma con notas en foto (escritorio) y chips con "★ Más elegido" (celular), contador
   pegado al botón, fecha de llegada, beneficios ("Tu casa olerá a…"), cómo usarlo en 3 pasos,
   garantía + WhatsApp, y header con el logo al centro.
   Se activa con la clase html.fl-refresh, que pone el script en línea del <head> de theme.liquid
   (vista previa: ?refresh=1, queda en la sesión; ?refresh=0 la apaga). Reusa las piezas del tema:
   florema-micro.js sigue manejando vuelo al carro, precio que baja, favoritos y cuentas regresivas. */
(function () {
  'use strict';
  var root = document.documentElement;
  if (!root.classList.contains('fl-refresh')) return;

  var NOTA = 'https://florema.cl/cdn/shop/files/fl-nota-';
  /* Notas en foto (recortes de las láminas de perfil de aroma) y textos de sensación */
  var AR = {
    'Bloom': { s: 'bloom', n: [['lavanda', 'Lavanda'], ['pomelo', 'Pomelo'], ['coco', 'Coco']], o: 'calma', w: ['Sereno', 'Luminoso', 'Delicado'],
      f: 'Como un campo de lavanda al atardecer, con un destello fresco de pomelo. Un aroma que calma la casa y te invita a desconectarte.',
      p: 'Para quien busca calma al llegar a casa: dormitorios y rincones de lectura.' },
    'Fresh': { s: 'fresh', n: [['limon', 'Limón'], ['pomelo', 'Pomelo'], ['sandalo', 'Sándalo']], o: 'limpio', w: ['Limpio', 'Vibrante', 'Fresco'],
      f: 'La sensación de una casa recién ventilada: cítricos chispeantes que se asientan en una calidez suave de maderas.',
      p: 'Para quien ama la sensación de limpio: living, cocina y espacios de trabajo.' },
    'Mangolú': { s: 'mangolu', n: [['mango', 'Mango'], ['naranja', 'Naranja'], ['ambar', 'Ámbar']], o: 'tarde de verano', w: ['Cálido', 'Soleado', 'Jugoso'],
      f: 'Fruta madura de verano que despierta los sentidos, con un fondo ámbar que abraza al caer la tarde.',
      p: 'Para quien quiere calidez y buena energía en los espacios compartidos.' },
    'Roma': { s: 'roma', n: [['rosas', 'Rosas'], ['frambuesa', 'Frambuesa'], ['vainilla', 'Vainilla']], o: 'ramo de rosas', w: ['Sofisticado', 'Romántico', 'Elegante'],
      f: 'Un ramo de rosas recién llegado con un toque dulce de frutos rojos. Envuelve el ambiente sin empalagar.',
      p: 'Para quien busca un toque elegante y romántico: living, dormitorio o para regalar.' },
    'Sugar': { s: 'sugar', n: [['arandano', 'Arándano'], ['jazmin', 'Jazmín'], ['pachuli', 'Pachulí']], o: 'tarde de manta y té', w: ['Dulce', 'Envolvente', 'Acogedor'],
      f: 'Frutos azules y flores blancas sobre un fondo profundo. Como una tarde de manta y té en casa.',
      p: 'Para quien quiere un hogar acogedor y dulce, sin empalagar.' },
    'Tropical': { s: 'tropical', n: [['mango', 'Mango'], ['durazno', 'Durazno'], ['coco', 'Coco']], o: 'verano', w: ['Fresco', 'Jugoso', 'Revitalizante'],
      f: 'Frutas recién cortadas y una brisa de verano. Llena la casa de energía y buen ánimo desde la mañana.',
      p: 'Para quien quiere una casa alegre y con energía desde la mañana.' },
    'Uvana': { s: 'uvana', n: [['platano', 'Plátano'], ['uva', 'Uva'], ['pina', 'Piña']], o: 'frutera de colores', w: ['Alegre', 'Frutal', 'Divertido'],
      f: 'Una frutera llena de color: dulce, alegre y nada empalagoso. Ideal para espacios con mucha vida.',
      p: 'Para hogares con mucha vida y espacios llenos de color.' },
    'Vitali': { s: 'vitali', n: [['verbena', 'Verbena'], ['limon', 'Limón'], ['bergamota', 'Bergamota']], o: 'mañana fresca', w: ['Revitalizante', 'Verde', 'Fresco'],
      f: 'Hojas recién cortadas con cítricos brillantes. Energía limpia para empezar el día con todo.',
      p: 'Para quien empieza el día con todo: oficinas, home office y cocinas.' },
    /* esencias (notas de sus láminas) */
    'Coffee': { s: 'coffee', n: [['cafe', 'Café'], ['cacao', 'Cacao']], o: 'café recién hecho', w: ['Cálido', 'Intenso', 'Acogedor'],
      f: 'El aroma de una cafetera recién hecha con un toque de cacao. La calidez de una cafetería en tu casa.',
      p: 'Para quien ama empezar el día con café y quiere una casa cálida.' },
    'Eucalipto': { s: 'eucalipto', n: [['eucalipto', 'Eucalipto'], ['menta', 'Menta']], o: 'aire fresco', w: ['Fresco', 'Limpio', 'Renovador'],
      f: 'Hojas de eucalipto y menta fresca: una bocanada de aire limpio que despeja el ambiente.',
      p: 'Para baños, dormitorios y quien busca sensación de frescura.' },
    'Lavanda': { s: 'lavanda', n: [['lavanda', 'Lavanda']], o: 'calma', w: ['Sereno', 'Relajante', 'Floral'],
      f: 'Un campo de lavanda en flor: el aroma clásico para bajar el ritmo y descansar.',
      p: 'Para dormitorios y momentos de descanso.' },
    'Manzana Canela': { s: 'manzana-canela', n: [['manzana', 'Manzana'], ['canela', 'Canela'], ['cedro', 'Cedro']], o: 'hogar en invierno', w: ['Cálido', 'Especiado', 'Acogedor'],
      f: 'Manzanas horneadas con canela sobre un fondo de cedro. Como una tarde de invierno en casa.',
      p: 'Para el living y la cocina, y para quien busca calidez.' },
    'Strawberry': { s: 'strawberry', n: [['fresa', 'Fresa'], ['frutos-rojos', 'Frutos rojos']], o: 'frutos rojos', w: ['Dulce', 'Frutal', 'Alegre'],
      f: 'Fresas maduras y frutos rojos: dulce, jugoso y alegre, sin empalagar.',
      p: 'Para espacios alegres y quien ama los aromas frutales.' },
    'Vainilla': { s: 'vainilla', n: [['vainilla', 'Vainilla'], ['jazmin', 'Jazmín']], o: 'vainilla', w: ['Dulce', 'Suave', 'Envolvente'],
      f: 'Vainilla cálida con un toque de jazmín. Suave, envolvente y reconfortante.',
      p: 'Para quien busca un aroma dulce y acogedor en cualquier espacio.' }
  };
  /* Feriados CL para la fecha de llegada (Santiago: 1 a 2 días hábiles) */
  /* videos que se muestran cuadrados y solo con la parte de arriba (en el del pack se ve una esencia abajo que no viene incluida) */
  var VIDEO_CUADRADO = { 'pack-home-spray-130ml-refil-home-spray-500ml': 1 };
  var FERIADOS = ['2026-10-12', '2026-10-31', '2026-11-01', '2026-12-08', '2026-12-25', '2027-01-01', '2027-04-02', '2027-04-03', '2027-05-01', '2027-05-21'];

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  function reinicia(e, c) { e.classList.remove(c); void e.offsetWidth; e.classList.add(c); setTimeout(function () { e.classList.remove(c); }, 700); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function num(t) { var d = String(t || '').replace(/[^\d]/g, ''); return d ? parseInt(d, 10) : 0; }
  function clp(n) { return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var desk = window.matchMedia('(min-width: 990px)');

  /* ---------- Notas del aroma: UN solo método en toda la web (el mismo de florema-packs.js) ----------
     Las 3 primeras notas de la línea "Notas principales de la fragancia …" de la descripción del producto del aroma
     (sin repetidas; si trae menos de 3, las que tenga). Si el producto no tiene esa línea, se cae al texto del chip. */
  function notaNorm(s) { return String(s || '').replace(/ /g, ' ').trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function notasLista(t) { /* "Rosas, frambuesa, dulce vainilla, ámbar" -> ['Rosas','Frambuesa','Vainilla'] (3 como máximo) */
    var vistos = {};
    return String(t || '').replace(/ /g, ' ').split(/\s*[·,]\s*|\s+y\s+/).map(function (x) { return x.trim().replace(/^dulce\s+/i, ''); })
      .filter(function (x) { var k = notaNorm(x); if (!k || vistos[k]) return false; vistos[k] = 1; return true; })
      .map(function (x) { return x.charAt(0).toUpperCase() + x.slice(1); }).slice(0, 3);
  }
  function notasDeDescripcion(html) {
    var p = String(html || '').split('Notas principales de la fragancia');
    if (p.length < 2) return [];
    var t = p[p.length - 1].split('</p>')[0].split(':').pop();
    try { t = new DOMParser().parseFromString(t.replace(/<[^>]+>/g, ' '), 'text/html').body.textContent || ''; } catch (e) { t = t.replace(/<[^>]+>/g, ' '); }
    return notasLista(t.replace(/\./g, ''));
  }

  var ICON = {
    star: '<svg viewBox="0 0 24 24"><path d="M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.9L12 16.9l-5.2 2.8 1-5.9L3.5 9.7l5.9-.8z"/></svg>',
    vial: '<svg viewBox="0 0 24 24"><path d="M9.5 3h5M10.5 3v5l-4 9a2 2 0 002 3h7a2 2 0 002-3l-4-9V3"/><path d="M8.5 15h7"/></svg>',
    drop: '<svg viewBox="0 0 24 24"><path d="M12 3c2 3 5 5 5 9a5 5 0 01-10 0c0-4 3-6 5-9z"/></svg>',
    clock: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.5"/><path d="M12 7v5l3 2"/></svg>',
    shield: '<svg viewBox="0 0 24 24"><path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>',
    truck: '<svg viewBox="0 0 24 24"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>',
    wa: '<svg viewBox="0 0 24 24"><path d="M4 20l1.3-3.9A8 8 0 1112 20a8 8 0 01-4-1.1z"/></svg>',
    s1: '<svg viewBox="0 0 24 24"><path d="M9 21h6l-1-8h-4z"/><path d="M10 13L7 3M12 13V2M14 13l3-10"/></svg>',
    s2: '<svg viewBox="0 0 24 24"><path d="M4 12a8 8 0 0114-5l2 2M20 12a8 8 0 01-14 5l-2-2"/><path d="M20 4v5h-5M4 20v-5h5"/></svg>',
    s3: '<svg viewBox="0 0 24 24"><path d="M6 21L11 3M10 21l3-18M14 21l1-18M18 21L17 3"/></svg>'
  };

  /* ---------- barra Cyber: regalo con ícono de línea; en celular (portada) los mensajes rotan en una 2ª fila ---------- */
  (function () {
    var m = document.querySelector('.florema-cyber-bar__msg--ship'); if (!m || m.querySelector('.fl-rf-cymsg')) return;
    var txt = (m.textContent || '').replace(/[\u{1F300}-\u{1FAFF}☀-➿️]/gu, '').replace(/\s+/g, ' ').trim();
    if (!txt) return;
    var partes = txt.split(/\s·\s/);
    var ico = '<svg class="fl-rf-cyber-ico" viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="8" width="18" height="4"/><path d="M12 8v13M5 12v9h14v-9M12 8c-2-4-6-4-6-1.5S10 8 12 8Zm0 0c2-4 6-4 6-1.5S14 8 12 8Z"/></svg>';
    m.innerHTML = '<span class="fl-rf-cymsg">' + partes.map(function (x, i) { return '<span class="fl-rf-cyit' + (i ? '' : ' on') + '">' + (/regalo/i.test(x) ? ico : '') + x.replace(/</g, '&lt;') + '</span>'; }).join('') + '</span>';
    var its = m.querySelectorAll('.fl-rf-cyit'), k = 0;
    if (its.length > 1) setInterval(function () { its[k].classList.remove('on'); k = (k + 1) % its.length; its[k].classList.add('on'); }, 3800);
  })();

  /* ---------- header: menú izquierda · logo al centro · íconos derecha (escritorio) ---------- */
  function header() {
    $$('.florema-hdr__nav .florema-hdr__nav-link').forEach(function (a) {
      var t = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^Packs Exclusivos/i.test(t)) {
        var tn = Array.prototype.filter.call(a.childNodes, function (n) { return n.nodeType === 3 && /Packs/i.test(n.nodeValue); })[0];
        if (tn) tn.nodeValue = tn.nodeValue.replace(/Packs Exclusivos/i, 'Packs');
      }
    });
  }

  /* aparecer al bajar (como Madison): secciones y tarjetas que están más abajo de la pantalla entran con un fade-up suave.
     Lo que se ve al cargar no se esconde nunca; respeta "reducir movimiento". */
  (function () {
    if (!('IntersectionObserver' in window) || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    var SEL = '.florema-cat-bento__cell, .florema-card, .florema-value__item, .florema-aroma-card, .florema-loc__item, .florema-page-faq__item, .fl-regalo, .fl-testi, main .shopify-section h2';
    var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { var t = en.target; t.classList.add('fl-in'); io.unobserve(t); setTimeout(function () { t.style.transitionDelay = ''; t.classList.remove('fl-rv', 'fl-in'); }, 1200); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    function preparar() {
      $$(SEL).forEach(function (e) {
        if (e.classList.contains('fl-rv') || e.closest('.florema-pdp__main, .florema-hdr, .florema-cart-drawer')) return;
        if (e.getBoundingClientRect().top < window.innerHeight * 0.92) return;
        var hermanos = e.parentElement ? Array.prototype.filter.call(e.parentElement.children, function (x) { return x.className === e.className; }) : [];
        var i = hermanos.indexOf(e);
        e.classList.add('fl-rv'); if (i > 0) e.style.transitionDelay = ((i % 4) * 90) + 'ms';
        io.observe(e);
      });
    }
    ready(preparar); window.addEventListener('load', function () { setTimeout(preparar, 300); });
  })();

  /* packs: la pastilla oscura se desliza del aroma anterior al nuevo (como en el selector de aromas) */
  document.addEventListener('click', function (e) {
    var lab = e.target.closest && e.target.closest('.florema-pdp__variants--rich label.florema-pdp__variant-chip');
    if (!lab || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    var g = lab.parentElement, prev = g.querySelector('input:checked + label');
    if (!prev || prev === lab) return;
    var gr = g.getBoundingClientRect(), a = prev.getBoundingClientRect(), b = lab.getBoundingClientRect();
    if (getComputedStyle(g).position === 'static') g.style.position = 'relative';
    var pill = document.createElement('span'); pill.className = 'fl-rf-pkpill';
    pill.style.cssText = 'left:' + (a.left - gr.left) + 'px;top:' + (a.top - gr.top) + 'px;width:' + a.width + 'px;height:' + a.height + 'px';
    g.appendChild(pill); g.classList.add('fl-rf-pk-mov');
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      pill.style.transform = 'translate(' + (b.left - a.left) + 'px,' + (b.top - a.top) + 'px)';
      pill.style.width = b.width + 'px'; pill.style.height = b.height + 'px';
    }); });
    setTimeout(function () { g.classList.remove('fl-rf-pk-mov'); pill.remove(); }, 430);
  }, true);

  /* "+" de "Combina bien con" y del catálogo de la ficha: agrega, actualiza el carro y lo abre (antes solo agregaba en silencio) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.florema-pdp__recommend-add-btn');
    if (!b || !b.form) return;
    e.preventDefault(); e.stopPropagation();
    if (b.disabled) return;
    b.disabled = true;
    /* misma animación que el botón principal: la foto vuela al carrito al instante; el carro se abre al llegar */
    var card = b.closest('.florema-pdp__recommend-card'), im = card && card.querySelector('img');
    if (window.FloremaFly && im) window.FloremaFly(im);
    fetch('/cart/add.js', { method: 'POST', body: new FormData(b.form), headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        b.classList.add('is-added'); b.textContent = '✓';
        var C = window.FloremaCart;
        setTimeout(function () {
          if (C && C.refresh) { var pr = C.refresh(); var abre = function () { if (C.open) C.open(); }; pr && pr.then ? pr.then(abre) : abre(); }
          else location.href = '/cart';
        }, window.FloremaFly && im ? 850 : 0);
      })
      .catch(function () { b.textContent = '!'; })
      .then(function () { setTimeout(function () { b.disabled = false; b.classList.remove('is-added'); b.textContent = '+'; }, 1600); });
  }, true);

  if (!/^\/products\//.test(location.pathname)) { ready(header); return; }

  ready(function () {
    header();
    var info = $('.florema-pdp__info');
    if (!info) return;
    var titulo = ($('.florema-pdp__title') || {}).textContent || document.title;
    var tl = titulo.toLowerCase();
    var esHumid = /humidificador/.test(tl), esBolsa = /bolsa/.test(tl);
    var esDifusor = /difusor/.test(tl) && !/auto|refil|refill/.test(tl) && !/\+|pack/.test(tl);
    var activo = $('.florema-pdp-aroma.is-active .florema-pdp-aroma__name');
    var aroma = activo ? activo.textContent.trim() : '';
    if (!aroma) Object.keys(AR).forEach(function (k) { if (!aroma && tl.indexOf(k.toLowerCase()) > -1) aroma = k; });
    var A = AR[aroma];

    /* reseñas: número destacado + cantidad verificada */
    var rt = $('.florema-pdp__rating-text');
    function rating() {
      var m = document.body.innerText.match(/Basado en (\d+) reseñas/);
      if (!rt) return;
      var nota = (rt.textContent.match(/\d+[.,]\d/) || ['4.9'])[0];
      rt.innerHTML = '<b>' + nota + '</b> · ' + (m ? m[1] + ' reseñas verificadas' : 'Ver reseñas');
    }
    rating(); setTimeout(rating, 2500);

    /* precio: etiqueta en degradado + "Ahorras $X" (se recalcula si cambia el precio) */
    var pr = $('.florema-pdp__price');
    if (pr) {
      var dsc = $('.florema-pdp__price-discount', pr);
      if (dsc) { dsc.classList.add('fl-rf-grad'); if (!/[−-]\d/.test(dsc.textContent)) dsc.textContent = '−' + dsc.textContent.trim();   /* el Liquid ya la entrega como "CYBER −20%" / "−20%" */ }
      var ah = el('span', 'fl-rf-ahorro'); pr.appendChild(ah);
      var tmr;
      var calc = function () {
        var a = num(($('.florema-pdp__price-amount', pr) || {}).textContent), c = $('.florema-pdp__price-compare', pr);
        var cv = c && getComputedStyle(c).display !== 'none' ? num(c.textContent) : 0;
        /* el ahorro en pesos solo convence cuando es grande; en montos chicos basta el % (mismo criterio que las colecciones) */
        ah.textContent = cv > a && a > 0 && cv - a >= 5000 ? 'Ahorras ' + clp(cv - a) : '';
      };
      new MutationObserver(function () { clearTimeout(tmr); tmr = setTimeout(calc, 1300); }).observe(pr, { childList: true, characterData: true, subtree: true });
      setTimeout(calc, 1500);
    }

    /* regalo: tarjeta con foto del difusor de auto y sello GRATIS */
    var rg = $('.fl-regalo-line');
    if (rg && !$('.fl-rf-rimg', rg)) {
      rg.insertBefore(el('img', 'fl-rf-rimg'), rg.firstChild).src = 'https://florema.cl/cdn/shop/files/freepik__edit-imagetoimage-flux-use-my-uploaded-product-ima__40225.png?width=120';
      rg.appendChild(el('em', 'fl-rf-gratis fl-rf-grad', 'Gratis'));
    }

    /* selector de aroma */
    var bloque = $('.florema-pdp-aromas'), chips = $$('.florema-pdp-aroma');
    if (bloque && chips.length > 1) {
      bloque.insertAdjacentElement('afterend', el('div', 'fl-rf-indeciso', ICON.shield + '<span><b>¿No te convence?</b> Te lo cambiamos en 30 días.</span>'));
      /* el tema agrega los aromas por partes: el selector se arma de nuevo cada vez que cambia la lista */
      var construir = function () {
      var vieja = $('.fl-rf-d', bloque); if (vieja) vieja.remove();
      var viejaM = $('.fl-rf-m', bloque); if (viejaM) viejaM.remove();
      chips = $$('.florema-pdp-aroma', bloque);
      var datos = chips.map(function (c) {
        return { a: c, href: c.getAttribute('href') || '', nm: (($('.florema-pdp-aroma__name', c) || {}).textContent || '').trim(),
          fam: (($('.florema-pdp-aroma__family', c) || {}).textContent || '').trim(), notas: (($('.florema-pdp-aroma__notes', c) || {}).textContent || '').trim(),
          col: (($('.florema-pdp-aroma__swatch', c) || {}).style || {}).background || '#ddd', on: c.classList.contains('is-active') };
      });
      /* selector de escritorio: miniaturas + tarjeta con notas en foto */
      var D = el('div', 'fl-rf-d'), fila = el('div', 'fl-rf-dfila'), nf = el('div', 'fl-rf-dnf');
      datos.forEach(function (d) {
        var t = el('a', 'fl-rf-dt' + (d.on ? ' on' : ''), '<img alt="" loading="lazy"><span>' + esc(d.nm) + '</span>');
        t.href = d.href; t.dataset.nm = d.nm; d.t = t; fila.appendChild(t);
      });
      D.appendChild(fila); D.appendChild(nf); bloque.appendChild(D);
      /* selector de celular (<750 px): fila deslizable de mini-frascos + notas del aroma elegido */
      var M = el('div', 'fl-rf-m'), mw = el('div', 'fl-rf-mwrap'), mr = el('div', 'fl-rf-mrail');
      mr.setAttribute('role', 'group'); mr.setAttribute('aria-label', 'Aroma');
      datos.forEach(function (d) {
        var m = el('a', 'fl-rf-mc' + (d.on ? ' on' : ''), '<span class="ph"><img alt="" loading="eager" draggable="false"></span><span class="lb">' + esc(d.nm) + '</span>');
        m.href = d.href; m.setAttribute('aria-label', d.nm); if (d.on) m.setAttribute('aria-current', 'true');
        d.m = m; mr.appendChild(m);
      });
      mw.appendChild(mr); M.appendChild(mw);
      var actM = datos.filter(function (d) { return d.on; })[0];
      /* notas del aroma de ESTA ficha: de la descripción del propio producto (que ya está en la página); sin esa línea, texto del chip */
      var descPag = ''; $$('.florema-pdp-accordion__body').some(function (b) { if (b.innerHTML.indexOf('Notas principales de la fragancia') > -1) { descPag = b.innerHTML; return true; } return false; });
      var notasPag = notasDeDescripcion(descPag);
      if (actM) actM.nl = notasPag.length ? notasPag : notasLista(actM.notas);
      if (actM && actM.nl.length) M.appendChild(el('div', 'fl-rf-mn', '<span class="k">Notas</span><b>' + esc(actM.nl.join(' · ')) + '</b>'));
      bloque.appendChild(M); bloque.classList.add('fl-rf-mob');
      /* deja visible el frasco elegido (lo centra solo si no se ve entero) sin mover la página: solo se desplaza la fila */
      var centra = function () {
        var on = actM && actM.m; if (!on || !mr.clientWidth) return;
        if (on.offsetLeft - mr.scrollLeft + on.offsetWidth > mr.clientWidth - 40 || on.offsetLeft < mr.scrollLeft) mr.scrollLeft = Math.max(0, on.offsetLeft - (mr.clientWidth - on.offsetWidth) / 2);
      };
      centra(); requestAnimationFrame(centra); setTimeout(centra, 400); window.addEventListener('load', centra);
      if (window.matchMedia) { var mq = matchMedia('(max-width: 749px)'); mq.addEventListener ? mq.addEventListener('change', centra) : mq.addListener(centra); }
      /* ficha del aroma elegido (escritorio): sin nombre (ya está en el título) ni caja; familia + sensaciones + notas (mismo método que el selector de celular) y 3 fotos de notas a la derecha */
      /* las notas del aroma (3, de la descripción) y, para cada una, su foto si existe en Files (si no, cuadro crema con el nombre) */
      var fotoNota = function (x, nombre) { /* "Limón de pica" -> foto "limon"; solo las fotos que existen en Files (lista AR.n) */
        var k = notaNorm(nombre), r = null;
        if (x) x.n.forEach(function (n) { if (!r && (notaNorm(n[1]) === k || k.indexOf(notaNorm(n[1]) + ' ') === 0)) r = n[0]; });
        return r ? NOTA + x.s + '-' + r + '.jpg?width=400' : '';
      };
      var tarjeta = function (src, nombre) {
        return '<span>' + (src ? '<img src="' + src + '" alt="' + esc(nombre) + '" decoding="async" fetchpriority="high">' : '<i class="nf">' + esc(nombre) + '</i>') + '<b>' + esc(nombre) + '</b></span>';
      };
      var shownD = null;
      var pinta = function (d) {
        shownD = d;
        var x = AR[d.nm], nl = d.nl && d.nl.length ? d.nl : (d.nl === undefined && x ? x.n.map(function (n) { return n[1]; }).slice(0, 3) : notasLista(d.notas));
        var h = '<div class="tx"><span class="fm">Familia ' + esc(d.fam) + '</span>';
        /* escritorio: las notas van en tarjetas (foto + nombre); la línea de texto "NOTAS …" solo si el aroma no tiene fotos de ninguna nota */
        var conFoto = nl.some(function (n) { return fotoNota(x, n); });
        if (nl.length && !conFoto) h += '<span class="nts"><span class="k">Notas</span><b>' + esc(nl.join(' · ')) + '</b></span>';
        h += '</div>';
        if (nl.length && conFoto) h += '<div class="tw"><span class="k">Notas</span><div class="tiles">' + nl.map(function (n) { return tarjeta(fotoNota(x, n), n); }).join('') + '</div></div>';
        var llave = d.nm + '|' + nl.join('|') + '|' + conFoto;
        if (nf.getAttribute('data-k') === llave && nf.firstChild) return;   /* ya está pintado: no se vuelve a crear (evita pedir otra vez las fotos al pasar el mouse) */
        nf.setAttribute('data-k', llave); nf.innerHTML = h;
        /* si una foto no carga (red lenta o cortada) se reintenta una vez; si vuelve a fallar queda el cuadro crema con el nombre, nunca un hueco en blanco */
        $$('.tiles img', nf).forEach(function (im) {
          var cae = function () {
            if (!im.dataset.r) { im.dataset.r = '1'; im.src = im.src + (im.src.indexOf('?') > -1 ? '&' : '?') + 'r=1'; return; }
            var nom = im.alt, f = el('i', 'nf', esc(nom)); if (im.parentNode) im.parentNode.replaceChild(f, im);
          };
          im.addEventListener('error', cae);
          setTimeout(function () { if (im.isConnected && !(im.complete && im.naturalWidth) && !im.dataset.r) { im.dataset.r = '1'; im.src = im.src + (im.src.indexOf('?') > -1 ? '&' : '?') + 'r=1'; } }, 5000);
        });
      };
      var act = datos.filter(function (d) { return d.on; })[0] || datos[0];
      pinta(act);
      /* precarga de las fotos de notas (la del aroma activo primero, el resto cuando la página ya cargó): así pasar el mouse por las miniaturas no vuelve a pedirlas ni deja huecos en blanco mientras llegan */
      if (window.matchMedia && matchMedia('(min-width: 750px)').matches) {
        var PRE = window.__flNotasPre = window.__flNotasPre || {};
        var precarga = function (d, alta) {
          var x = AR[d.nm]; if (!x) return;
          x.n.forEach(function (n) { var u = NOTA + x.s + '-' + n[0] + '.jpg?width=400'; if (PRE[u]) return; var im = new Image(); try { im.fetchPriority = alta ? 'high' : 'low'; } catch (e) {} im.src = u; PRE[u] = im; });
        };
        precarga(act, true);
        var resto = function () { setTimeout(function () { datos.forEach(function (d) { if (d !== act) precarga(d, false); }); }, 1200); };
        if (document.readyState === 'complete') resto(); else window.addEventListener('load', resto);
      }
      /* vista previa al pasar el mouse: la miniatura en negrita SIEMPRE es la de las notas que se ven (antes quedaba en negrita el aroma de la página con las notas de otro) */
      var marca = function (d) { datos.forEach(function (x) { x.t.classList.toggle('on', x === d); }); pinta(d); };
      datos.forEach(function (d) { d.t.addEventListener('mouseenter', function () { marca(d); }); d.t.addEventListener('focus', function () { marca(d); }); d.t.addEventListener('blur', function () { marca(act); }); });
      fila.addEventListener('mouseleave', function () { marca(act); });
      /* fotos de cada aroma y "★ Aroma favorito" (tag aroma-top, mismo nombre que en las tarjetas) desde el JSON público del producto */
      datos.forEach(function (d) {
        var h = (d.href.split('/products/')[1] || '').split(/[?#]/)[0];
        if (!h) return;
        var k = 'flRfP2:' + h, aplica = function (p) {
          d.nl = p.notes || []; if (d === shownD) pinta(d);
          if (p.img) { $('img', d.t).src = p.img; var mi = d.m && $('img', d.m); if (mi) mi.src = p.img; }
          if (p.top) { [d.a, d.t].forEach(function (n) { if (!$('.fl-rf-top', n)) n.insertBefore(el('span', 'fl-rf-top', '<i>★</i>Aroma favorito'), n.firstChild); }); }
        };
        var c; try { c = JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) {}
        if (c) return aplica(c);
        fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (p) {
          var img = p.featured_image ? String(p.featured_image).replace(/^\/\//, 'https://') + (String(p.featured_image).indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
          var o = { img: img, top: (p.tags || []).indexOf('aroma-top') > -1, notes: notasDeDescripcion(p.description) };
          try { sessionStorage.setItem(k, JSON.stringify(o)); } catch (e) {}
          aplica(o);
        }).catch(function () {});
      });
      };
      construir();
      var grid = $('.florema-pdp-aromas__grid', bloque), tmrD;
      if (grid) new MutationObserver(function () { clearTimeout(tmrD); tmrD = setTimeout(construir, 150); }).observe(grid, { childList: true });
    }

    /* contador: franja en degradado pegada al botón */
    var cd = $('.florema-pdp-countdown');
    if (cd) {
      var tit = $('.florema-pdp-countdown__title', cd);
      if (tit) tit.firstChild && tit.firstChild.nodeType === 3 ? (tit.firstChild.nodeValue = 'Precio Cyber termina en') : tit.insertBefore(document.createTextNode('Precio Cyber termina en'), tit.firstChild);
      var MAP = { 'días': 'd', 'dias': 'd', 'horas': 'h', 'min': 'm', 'seg': 's' };
      $$('.florema-pdp-countdown__t', cd).forEach(function (t) { var k = t.textContent.trim().toLowerCase(); if (MAP[k]) t.textContent = MAP[k]; });
    }

    /* fecha de llegada: Santiago 24–48 h hábiles (despacho al día hábil siguiente) → entre 1 y 2 días hábiles; salta fines de semana y feriados CL */
    var llegada = (function () {
      function k(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
      function habil(n) { var d = new Date(), c = 0; while (c < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6 && FERIADOS.indexOf(k(d)) < 0) c++; } return d; }
      function dia(d) { return d.toLocaleDateString('es-CL', { weekday: 'long', day: 'numeric' }).replace(',', ''); }
      function mes(d) { return d.toLocaleDateString('es-CL', { month: 'long' }); }
      var d1 = habil(1), d2 = habil(2);
      return d1.getMonth() === d2.getMonth()
        ? dia(d1) + ' o ' + dia(d2)
        : dia(d1) + ' de ' + mes(d1) + ' o ' + dia(d2) + ' de ' + mes(d2);
    })();
    info.appendChild(el('div', 'fl-rf-llega', ICON.truck + '<span><b>Recíbelo el ' + llegada + '</b> en Santiago<small>Regiones: 3 a 5 días hábiles · <b>Gratis sobre $50.000</b></small></span>'));

    /* beneficios */
    var acc = $$('.florema-pdp-accordion details');
    function accItem(nombre) { return acc.filter(function (d) { var s = $('summary', d); return s && s.textContent.replace(/\s+/g, ' ').trim().toLowerCase().indexOf(nombre) === 0; })[0]; }
    function accTexto(d) { if (!d) return ''; var c = d.cloneNode(true), s = $('summary', c); if (s) s.remove(); return c.textContent.replace(/\s+/g, ' ').trim(); }
    var filas = [];
    if (A && !esHumid && !esBolsa) {
      filas.push('<div class="fl-rf-bi">' + ICON.drop + '<div><b>' + (/auto/.test(tl) ? 'Tu auto' : 'Tu casa') + ' olerá a ' + A.o + ':</b><p><span class="sw">' + A.w.map(function (w) { return '<i>' + w + '</i>'; }).join('') + '</span>' + A.f + '</p><p class="para"><b>¿Para quién es?</b> ' + A.p + '</p></div></div>');
    }
    var dur = accItem('duración');
    if (esDifusor) {
      var t = /150/.test(tl) ? '2 a 3 meses' : (/100/.test(tl) ? 'alrededor de 2 meses' : '');
      if (t) { filas.push('<div class="fl-rf-bi">' + ICON.clock + '<div><b>Se queda, no se va en minutos</b><p>Perfuma día y noche durante ' + t + ', sin llama ni electricidad. Depende de la ventilación y de cuántas varillas uses.</p></div></div>'); if (dur) dur.classList.add('fl-rf-oculto'); }
    } else if (dur && accTexto(dur)) {
      filas.push('<div class="fl-rf-bi">' + ICON.clock + '<div><b>¿Cuánto dura?</b><p>' + esc(accTexto(dur)) + '</p></div></div>'); dur.classList.add('fl-rf-oculto');
    }
    if (!esHumid && !esBolsa) filas.push('<div class="fl-rf-bi">' + ICON.shield + '<div><b>' + (/auto/.test(tl) ? 'Fragancia certificada' : 'Seguro para tu hogar') + '</b><p>Fragancias certificadas bajo la norma internacional IFRA. Hechas en Chile.</p></div></div>');
    if (filas.length) info.appendChild(el('div', 'fl-rf-bnf', filas.join('')));

    /* cómo usarlo en 3 pasos (difusores de varillas) */
    if (esDifusor) {
      info.appendChild(el('div', 'fl-rf-pasos', '<div class="ph">Cómo usarlo</div><ol>' +
        '<li><i>1</i>' + ICON.s1 + '<span><b>Inserta las varillas</b> en el frasco</span></li>' +
        '<li><i>2</i>' + ICON.s2 + '<span><b>Voltéalas</b> cada 5 a 7 días</span></li>' +
        '<li><i>3</i>' + ICON.s3 + '<span><b>Más varillas</b>, más aroma</span></li></ol>'));
      var mu = accItem('modo de uso'); if (mu) mu.classList.add('fl-rf-oculto');
    }

    /* garantía + WhatsApp + Chile (la garantía del formulario baja hasta aquí) */
    var g = $('.florema-pdp__form .fl-garantia');
    var wa = $('a[href*="wa.me"]');
    var gh = '';
    if (g) gh += '<div class="fl-rf-gar">' + ICON.shield + '<span>' + (esHumid ? '<b>Compra segura.</b> Si llega con falla, avísanos dentro de 48 horas con una foto y te enviamos un reemplazo sin costo.' : g.querySelector('.fl-garantia__txt').innerHTML) + '</span></div>';
    gh += '<a class="fl-rf-wa" target="_blank" rel="noopener" href="' + esc(wa ? wa.getAttribute('href') : 'https://wa.me/56935083745') + '">' + ICON.wa + '<span><b>¿Dudas?</b> Escríbenos por WhatsApp y te ayudamos a elegir</span><em>→</em></a>';
    gh += '<div class="fl-rf-chile">Hecho en Chile · 4 tiendas Mall Plaza</div>';
    info.appendChild(el('div', 'fl-rf-garbox', gh));

    /* escritorio: video como una foto más de la columna izquierda */
    var main = $('.florema-pdp-gallery__main'), pv = $('.florema-pvid video');
    if (main && pv) {
      var vs = el('div', 'fl-rf-vslide');
      var v = pv.cloneNode(true); v.muted = true; v.setAttribute('muted', ''); v.autoplay = true; v.loop = true; v.setAttribute('playsinline', '');
      vs.appendChild(v);
      var ht = $('.florema-pvid__title'), hs = $('.florema-pvid__sub');
      vs.appendChild(el('div', 'cap', '<span>Video</span><b>' + esc(ht ? ht.textContent : '') + '</b><p>' + esc(hs ? hs.textContent : '') + '</p>'));
      var cuadrado = !!VIDEO_CUADRADO[(location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0]];
      if (cuadrado) { root.classList.add('fl-rf-vsq'); vs.style.setProperty('--fl-rf-ar', '1 / 1'); }
      var ar = function () { if (!cuadrado && v.videoWidth && v.videoHeight) vs.style.setProperty('--fl-rf-ar', v.videoWidth + ' / ' + v.videoHeight); };
      v.addEventListener('loadedmetadata', ar); ar();
      /* después de la primera foto del producto (no de la foto de notas de un pack) */
      var slides = $$('.florema-pdp-gallery__slide', main).filter(function (x) { return !x.hasAttribute('data-pack-aroma'); });
      if (slides[0]) slides[0].insertAdjacentElement('afterend', vs); else main.appendChild(vs);
      var vp = function () { if (desk.matches) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); };
      vp(); desk.addEventListener ? desk.addEventListener('change', vp) : desk.addListener(vp);
    }
    /* láminas con texto: completas, sin recortar */
    var hnd = (location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0].toLowerCase();
    $$('.florema-pdp-gallery__slide img').forEach(function (im) {
      var src = (im.getAttribute('src') || '').toLowerCase();
      if ((hnd && /^[^?]*\/([^/?]+)$/.test(src.split('?')[0]) && src.split('?')[0].split('/').pop().replace(/\.(png|jpe?g|webp)$/, '').replace(/_[0-9a-f]{8}-[0-9a-f-]{27}$/, '') === hnd) || /^(perfil-aroma|pack-nota)/.test(im.alt || '') || im.closest('[data-pack-aroma]')) im.closest('.florema-pdp-gallery__slide').classList.add('fl-lamina');
    });

    /* aparición suave al bajar (beneficios, pasos, garantía); no se activa si el usuario pidió menos movimiento */
    if ('IntersectionObserver' in window && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      var vis = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('fl-rf-in'); vis.unobserve(en.target); } }); }, { threshold: 0.15 });
      $$('.fl-rf-bi, .fl-rf-pasos li, .fl-rf-gar, .fl-rf-wa').forEach(function (x, i) { x.classList.add('fl-rf-rv'); x.style.transitionDelay = ((i % 3) * 80) + 'ms'; vis.observe(x); });
    }

    /* escritorio: la columna derecha se queda fija y, si es más alta que la pantalla, baja hasta mostrar su final */
    /* barra fija de compra estilo Madison (escritorio): foto + nombre + aroma, precio aparte y botón */
    var stk = $('.florema-pdp__sticky'), sInfo = stk && $('.florema-pdp__sticky-info', stk);
    if (sInfo && !$('.fl-rf-st-img', stk)) {
      var primera = $$('.florema-pdp-gallery__slide').filter(function (x) { return !x.hasAttribute('data-pack-aroma'); })[0];
      var pim = primera && $('img', primera);
      var stImg = el('img', 'fl-rf-st-img'); stImg.alt = '';
      if (pim) stImg.src = (pim.getAttribute('src') || '').replace(/([?&])width=\d+/, '$1width=160');
      var stTx = el('div', 'fl-rf-st-tx', '<b>' + esc(titulo.trim()) + '</b>'), sub = el('div', 'fl-rf-st-sub');
      Array.prototype.slice.call(sInfo.children).forEach(function (c) { sub.appendChild(c); });
      stTx.appendChild(sub); sInfo.appendChild(stImg); sInfo.appendChild(stTx);
      var spr = $('[data-pdp-sticky-price]', stk), pr2 = el('span', 'fl-rf-st-precio');
      var stBtn = $('.florema-pdp__sticky-btn', stk);
      if (spr && stBtn) {
        stBtn.parentNode.insertBefore(pr2, stBtn.previousElementSibling && stBtn.previousElementSibling.classList.contains('florema-pdp__sticky-qty') ? stBtn.previousElementSibling : stBtn);
        var cp = function () { var t = spr.textContent.trim(); if (pr2.textContent && pr2.textContent !== t) reinicia(pr2, 'fl-rf-pop'); pr2.textContent = t; }; cp();
        new MutationObserver(cp).observe(spr, { childList: true, characterData: true, subtree: true });
      }
      /* micro-animaciones de la barra: la cantidad rueda, el botón confirma y el producto vuela desde la miniatura */
      var sVal = $('[data-sticky-qty-val]', stk);
      if (sVal) {
        var sPrev = parseInt(sVal.textContent, 10) || 1;
        new MutationObserver(function () {
          var v = parseInt(sVal.textContent, 10) || 1;
          if (v !== sPrev) reinicia(sVal, v > sPrev ? 'fl-roll-up' : 'fl-roll-down');
          sPrev = v;
        }).observe(sVal, { childList: true, characterData: true, subtree: true });
      }
      if (stBtn) stBtn.addEventListener('click', function () {
        if (stBtn.classList.contains('fl-rf-st-ok')) return;
        window.__flFlyDesde = stImg;
        var lab = $('.florema-pdp__sticky-btn-label', stBtn), orig = lab ? lab.textContent : '';
        reinicia(stBtn, 'fl-rf-st-pulso');
        setTimeout(function () {
          stBtn.classList.add('fl-rf-st-ok'); if (lab) lab.textContent = '✓ Agregado';
          setTimeout(function () { stBtn.classList.remove('fl-rf-st-ok'); if (lab) lab.textContent = orig; }, 1500);
        }, 900);
      }, true);
    }
    try { [].forEach.call(document.querySelectorAll('.florema-pdp__recommend-sub, .florema-pdp__recommend-card small'), function (x) { x.textContent = x.textContent.replace(/car essence/i, 'Difusor de auto'); }); } catch (e) {}
    /* packs: la etiqueta sobre el título dice "Pack", no la familia del aroma por defecto (el pack se arma con cualquier aroma) */
    try {
      var fam = $('.florema-pdp__family');
      if (fam && /^\/products\/pack-/.test(location.pathname)) {
        var pk = function () { if (fam.textContent !== 'Pack') fam.textContent = 'Pack'; };
        pk(); new MutationObserver(pk).observe(fam, { childList: true, characterData: true, subtree: true });
      }
    } catch (e) {}
    /* reglas únicas de etiquetas (REGLAS-etiquetas-precios.md): el % siempre como "CYBER −20%" y con signo menos real */
    try {
      var fmtDesc = function () {
        [].forEach.call(document.querySelectorAll('.florema-cyber-badge, .florema-sale-badge, .florema-pdp__price-discount'), function (b) {
          var t = (b.textContent || '').replace(/\s+/g, ' ').trim(), m = t.match(/^[-−]\s?(\d+)%\s*(CYBER)?$/i);
          if (m) { var n = (m[2] ? 'CYBER ' : '') + '−' + m[1] + '%'; if (t !== n) b.textContent = n; }
        });
      };
      fmtDesc(); setTimeout(fmtDesc, 1500); setTimeout(fmtDesc, 4000);
    } catch (e) {}
    /* insignia social de la galería con el mismo estilo de las tarjetas (estrella dorada aparte) */
    try { [].forEach.call(document.querySelectorAll('.florema-pdp .florema-bestseller-badge'), function (b) { if (b.querySelector('i')) return; var t = (b.textContent || '').replace(/^\s*★\s*/, '').trim(); if (t) b.innerHTML = '<i>★</i>' + t; }); } catch (e) {}
    /* ---------- "parte de abajo" nueva, publicada en celular el 16-oct-2026 (ABAJO_LIVE) ----------
       Reorganiza lo que viene después de entrega + medios de pago: aroma → tira de íconos → "Combina bien con" → foto de ambiente → 4 acordeones.
       Tres interruptores independientes (false = solo vista previa con ?abajo=1, que queda en la sesión; ?abajo=0 la apaga):
         ABAJO_LIVE        celular (<750 px), productos de aroma (difusores, home spray, auto, refil, esencias)   → PUBLICADO
         ABAJO_DESK_LIVE   escritorio y tablet (≥750 px), mismos productos                                       → solo vista previa
         ABAJO_TODOS_LIVE  packs, humidificadores y bolsa de regalo (celular y escritorio)                       → solo vista previa */
    try {
      var abQ = new URLSearchParams(location.search).get('abajo'), abOn = false;
      var ABAJO_LIVE = true;
      var ABAJO_DESK_LIVE = true;
      var ABAJO_TODOS_LIVE = true;
      var abHnd = (location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0].toLowerCase();
      var abPack = /^pack-/.test(abHnd) || /\+/.test(tl) || /\bpack\b/.test(tl);
      var tipoA = esHumid ? 'humid' : (esBolsa ? 'bolsa' : (abPack ? 'pack' : 'std'));
      var abAncho = !!(window.matchMedia && matchMedia('(min-width: 750px)').matches);
      var abLive = tipoA === 'std' ? (abAncho ? ABAJO_DESK_LIVE : ABAJO_LIVE) : ABAJO_TODOS_LIVE;
      try {
        if (abQ === '1') sessionStorage.setItem('fl_abajo', '1'); else if (abQ === '0') sessionStorage.setItem('fl_abajo', '0');
        var abS = sessionStorage.getItem('fl_abajo');
        abOn = abS === '1' || (abLive && abS !== '0');
      } catch (e) { abOn = abQ === '1' || (abLive && abQ !== '0'); }
      if (abOn) (function () {
        var tx = function (e) { return ((e && e.textContent) || '').replace(/\s+/g, ' ').trim(); };
        var off = function (e) { if (e) e.classList.add('fl-ab-off'); };
        root.classList.add('fl-abajo');

        /* 1. "Tu casa olerá a…": título + chips + una frase; "¿Para quién es?" se va a Descripción; duración suelta y "Seguro para tu hogar" fuera.
              (packs, humidificadores y bolsa no tienen "olerá a": el bloque queda vacío y se retira) */
        var bnfA = $('.fl-rf-bnf', info), paraHTML = '';
        $$('.fl-rf-bi', bnfA || document.createElement('div')).forEach(function (b) {
          var bt = (b.querySelector('b') || {}).textContent || '';
          if (/olerá a/i.test(bt)) { var pr = $('p.para', b); if (pr) { paraHTML = pr.innerHTML; pr.remove(); } } else b.remove();
        });
        if (bnfA && !$('.fl-rf-bi', bnfA)) off(bnfA);
        var sinBnf = !bnfA || !$('.fl-rf-bi', bnfA);

        /* duración OFICIAL por formato (la que dicen las descripciones); si no se reconoce, se lee la línea "Duración:" de la descripción */
        var accA = $('.florema-pdp__accordion-inline', info) || $('.florema-pdp-accordion', info);
        var itemsA = accA ? $$('details', accA) : [];
        var itemNom = function (d) { return tx($('summary', d) || document.createElement('i')); };
        var cuerpoDe = function (d) { return $('.florema-pdp-accordion__body', d); };
        var descD = itemsA.filter(function (d) { return /^Descripci/i.test(itemNom(d)); })[0];
        var durTxt = '', durHTML = '';
        if (tipoA === 'pack') {
          /* cada producto del pack con su duración oficial; el Pack Descubrimiento (7 esencias) no lleva ícono de duración */
          var PK_DUR = { 'pack-difusor-150ml-home-spray-250ml': ['Difusor ~2,5 meses', 'Spray ~2 meses'], 'pack-difusor-100ml-home-130ml': ['Difusor ~2 meses', 'Spray ~1 mes'], 'pack-home-spray-130ml-refil-home-spray-500ml': ['Spray ~1 mes', 'Refil: 2 a 3 recargas'] };
          var pkd = PK_DUR[abHnd];
          if (pkd) durHTML = pkd.map(esc).join('<br>');
        } else if (tipoA === 'humid') {
          var hDur = itemsA.filter(function (d) { return /^Duraci/i.test(itemNom(d)); })[0], hm = hDur && tx(cuerpoDe(hDur)).match(/Autonom[ií]a:?\s*(\d+)\s*a\s*(\d+)\s*horas.*?hasta\s*(\d+)\s*horas/i);
          if (hm) durHTML = 'Autonomía ' + hm[1] + ' a ' + hm[2] + ' h<br>(hasta ' + hm[3] + ' h)';
        } else if (tipoA === 'std') {
          if (/auto/.test(tl)) durTxt = 'Dura aprox. 15 días';
          else if (/refil|refill/.test(tl)) durTxt = 'Rinde 2 a 3 recargas';
          else if (/esencia/.test(tl)) durTxt = 'Rinde aprox. 290 gotas';
          else if (/difusor/.test(tl) && /150/.test(tl)) durTxt = 'Dura aprox. 2,5 meses';
          else if (/difusor/.test(tl) && /(^|\D)(100|110)\s?ml/.test(tl)) durTxt = 'Dura aprox. 2 meses';
          else if (/home spray/.test(tl) && /250/.test(tl)) durTxt = 'Dura aprox. 2 meses';
          else if (/home spray/.test(tl) && /130/.test(tl)) durTxt = 'Dura aprox. 1 mes';
          else if (descD) {
            $$('.florema-pdp-accordion__body p', descD).forEach(function (p) {
              var m = !durTxt && tx(p).match(/^Duraci[oó]n\s*:\s*([^.,;]+)/i);
              if (m) { var v = m[1].replace(/\s*aproximadamente\s*/i, '').replace(/\s*aprox\.?\s*/i, '').trim(); if (v) durTxt = 'Dura aprox. ' + v.replace(/ /g, ' '); }
            });
          }
          if (durTxt) durHTML = esc(durTxt);
        }

        /* 2. tira de íconos (una fila), solo con datos que la propia ficha ya dice */
        var tiraH;
        if (tipoA === 'humid') {
          var warrT = tx($('.florema-pdp__warranties'));
          tiraH = (/cualquier esencia/i.test(warrT) ? '<div>' + ICON.drop + '<span>Úsalo con cualquier esencia Florema</span></div>' : '') +
            (durHTML ? '<div>' + ICON.clock + '<span>' + durHTML + '</span></div>' : '') +
            '<div>' + ICON.shield + '<span>Compra segura · Reemplazo si llega con falla</span></div>';
        } else if (tipoA === 'bolsa') {
          tiraH = '<div>' + ICON.truck + '<span>Envío gratis sobre $50.000</span></div><div>' + ICON.shield + '<span>Cambios y devoluciones hasta 30 días</span></div>';
        } else if (abHnd === 'pack-descubrimiento-nuestro-top-7-esencias') {
          /* Pack Descubrimiento: en vez de duración, el beneficio del pack (textos que la propia ficha ya dice: "7 esencias de 10 ml", "nuestras 7 esencias favoritas") */
          tiraH = '<div>' + ICON.vial + '<span>7 esencias de 10 ml</span></div><div>' + ICON.star + '<span>Las favoritas de Florema</span></div><div>' + ICON.drop + '<span>Esencia concentrada</span></div>';
        } else {
          tiraH = '<div>' + ICON.drop + '<span>Esencia concentrada</span></div>' +
            (durHTML ? '<div>' + ICON.clock + '<span>' + durHTML + '</span></div>' : '') +
            '<div>' + ICON.shield + '<span>Norma IFRA · Hecho en Chile</span></div>';
        }
        info.appendChild(el('div', 'fl-ab-tira' + (sinBnf ? ' fl-ab-tira--solo' : ''), tiraH));

        /* 4. foto de ambiente sin texto (reemplaza la banda "Aroma constante, día y noche"): difusores, home spray, auto, refil, esencias y packs de difusor + spray.
              Celular: dentro de la columna, entre "Combina bien con" y los acordeones. Escritorio/tablet: a ancho completo justo después de la ficha (antes de las reseñas).
              Humidificadores, bolsa, Pack Home Spray + Refil y Pack Descubrimiento no llevan (la foto mostraría otros productos). */
        var esVarillas = /difusor/.test(tl) && !/auto|refil|refill/.test(tl);
        var conFoto = tipoA === 'std' || (tipoA === 'pack' && /^pack-difusor-/.test(abHnd));
        if (conFoto) {
          if (abAncho) {
            /* escritorio/tablet: SIN foto de ambiente ni banda de video (Luis 16-oct: los videos ya van entre las fotos de la galería) */
          } else {
            var vA = esVarillas && tipoA === 'std';
            var fotoA = el('figure', 'fl-ab-foto' + (vA ? ' fl-ab-foto--v' : ''),
              '<img src="https://florema.cl/cdn/shop/files/' + (vA ? 'flh-vid-varillas-te-sala-poster.jpg' : 'flh-hero-living-mesa-te-difusor-spray.jpg') + '?width=900" alt="' +
              (vA ? 'Difusor de varillas Florema sobre una bandeja dorada en un living' : 'Home spray y difusor Florema sobre una bandeja dorada en un living') + '" loading="lazy" decoding="async">');
            info.appendChild(fotoA);
          }
          off($('.florema-pvid'));
        }

        /* 6. se retira: garantía larga + "¿Dudas?" + "Hecho en Chile" sueltos, "Productos complementarios" */
        var gbA = $('.fl-rf-garbox', info), chileA = gbA && $('.fl-rf-chile', gbA), garSpan = gbA && $('.fl-rf-gar span', gbA);
        var garHTML = garSpan ? garSpan.innerHTML : '';
        var chileTx = chileA ? tx(chileA) : 'Hecho en Chile · 4 tiendas Mall Plaza';
        off(gbA);
        /* "Más de {Aroma}" (florema-product-related, tras las reseñas) ya NO se retira; si la ficha no es de uno de los 8 aromas la sección sale vacía y se esconde */
        var relA = document.querySelector('[id$="__related"]'); if (relA && !relA.querySelector('.flk-card')) off(relA);
        var pasosA = $('.fl-rf-pasos', info);

        /* 5. acordeones: cerrados, máximo 4 (Descripción, Cómo se usa, Cuidados, Envíos y devoluciones), uno abierto a la vez; los que vienen vacíos se esconden */
        itemsA.forEach(function (d) {
          var nm = itemNom(d), body = cuerpoDe(d), hay = !!body && tx(body) !== '' && tx(body) !== nm;
          d.removeAttribute('open');
          if (/^Descripci/i.test(nm)) {
            if (!hay) { off(d); return; }
            d.classList.remove('fl-rf-oculto');
            if (tipoA === 'std') {
              var keep = $$('p', body).filter(function (p) { return /^(Notas principales|Contenido neto|Duraci)/i.test(tx(p)); });
              if (keep.length) {
                var h = keep.map(function (p) { return '<p>' + p.innerHTML.replace(/&nbsp;/g, ' ') + '</p>'; }).join('');
                if (paraHTML) h += '<p>' + paraHTML + '</p>';
                h += '<p>' + esc(chileTx) + '</p>';
                body.innerHTML = h;
              }
            } else if (tipoA === 'pack') {
              body.insertAdjacentHTML('beforeend', '<p>' + esc(chileTx) + '</p>');   /* la descripción del pack se deja completa */
            }
          } else if (/^(Modo de uso|C[oó]mo)/i.test(nm)) {
            var lab = $('summary .florema-pdp-accordion__summary-left span:last-child', d); if (lab) lab.textContent = 'Cómo se usa';
            if (pasosA) { d.classList.remove('fl-rf-oculto'); body.innerHTML = ''; body.appendChild(pasosA); }
            else if (hay) d.classList.remove('fl-rf-oculto'); else off(d);
          } else if (/^Cuidados/i.test(nm)) {
            if (hay) d.classList.remove('fl-rf-oculto'); else off(d);
          } else if (/^Env[ií]os/i.test(nm)) {
            if (!hay) { off(d); return; }
            d.classList.remove('fl-rf-oculto');
            /* la garantía suelta se retira de abajo: no se pierde, queda aquí (packs: cambio de aroma 30 días; humidificadores: compra segura) */
            if ((tipoA === 'pack' || tipoA === 'humid') && garHTML) body.insertAdjacentHTML('beforeend', '<p>' + garHTML + '</p>');
          } else off(d);   /* "Duración" suelta u otros: fuera */
        });
        if (accA) accA.addEventListener('toggle', function (ev) {
          var t = ev.target; if (!t.open) return;
          $$('details', accA).forEach(function (d) { if (d !== t) d.removeAttribute('open'); });
        }, true);
      })();
    } catch (e) { try { root.classList.remove('fl-abajo'); } catch (e2) {} }
    root.classList.add('fl-rf-listo');
    var fija = function () { root.style.setProperty('--fl-rf-top', Math.min(0, window.innerHeight - info.offsetHeight) + 'px'); };
    fija(); window.addEventListener('resize', fija, { passive: true });
    $$('.florema-pdp-accordion details').forEach(function (d) { d.addEventListener('toggle', fija); });
    setTimeout(fija, 1500); setTimeout(fija, 4000);
  });
})();
